import {
  Box,
  CardHeader,
  Container,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { Component } from "react";
import { Fade } from "react-reveal";
import sideBanner from "./../assests/images/EscaLandingPage.png";

export default class AboutEsca extends Component {
  render() {
    return (
      <section
        id="About Esca"
        className="w-100"
      >
        <Box style={{ background: "#893da1" }}>
        <Container className="about w-100">
          <Fade top>
            <div className="heading text-center section-padding">
              <h6
                className="sub-title animated text-white"
                data-animation="fadeInUpShorter"
                data-animation-delay="0.2s"
              >
                What is ESCA Token
              </h6>
              <h2
                className="title animated text-white"
                data-animation="fadeInUpShorter"
                data-animation-delay="0.3s"
              >
                About <strong>Esca Token</strong>
              </h2>
              <div
                className="separator animated"
                data-animation="fadeInUpShorter"
                data-animation-delay="0.3s"
              >
                <span className="large" />
                <span className="medium" />
                <span className="small" />
              </div>
              <p
                className="content-desc animated text-white"
                data-animation="fadeInUpShorter"
                data-animation-delay="0.4s"
              >
                Our vision is to enable anyone with a passion for food to
                monetize that passion. The Esca token will be the native utility
                token of escamenu.com and is designed to foster mainstream
                crypto adoption via crypto cashback. We aim to bring more people
                into digital assets, helping them earn a passive income through
                the use of food and cryptocurrencies in the Esca ecosystem.
                <br />
              </p>
            </div>
          </Fade>
        </Container>
        </Box>
        <Box style={{ padding: "20px" }}>
          <Container>
            <Grid container gutterBottom spacing={3}>
              <Grid item xs={12} sm={6} className="my-auto">
                <div
                  className="animated"
                  data-animation="fadeInLeftShorter"
                  data-animation-delay="0.5s"
                >
                  <Fade top>
                    <CardHeader
                      title={
                        <Typography
                          className="text-left w-100"
                          component="h4"
                          variant="h4"
                        >
                          We’re building a platform that lets food consumers and
                          producers generate passive income from eating and
                          selling food.
                        </Typography>
                      }
                    />
                  </Fade>
                  <Fade left>
                    <List>
                      <ListItem>
                        <ListItemText
                          primary={
                            <Typography component="p" variant="p">
                              {" "}
                              Presale 1: 21st March - 23rd March, $0.30, 750K
                              tokens
                            </Typography>
                          }
                        ></ListItemText>
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary={
                            <Typography component="p" variant="p">
                              {" "}
                              Presale 2: 24th March - 27th March, $0.40, 750K
                              tokens
                            </Typography>
                          }
                        ></ListItemText>
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary={
                            <Typography component="p" variant="p">
                              {" "}
                              IDO: 28th March - 1st April, $0.60, 1.5M Tokens
                            </Typography>
                          }
                        ></ListItemText>
                      </ListItem>
                    </List>
                  </Fade>
                </div>
              </Grid>
              <Grid className="my-auto" item xs={12} sm={6}>
                <div
                  className="animated"
                  data-animation="fadeInRightShorter"
                  data-animation-delay="0.5s"
                >
                  <div className="position-relative float-xl-right what-is-crypto-img">
                    <Fade right>
                      <img src={sideBanner} className="w-100" />
                    </Fade>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </section>
    );
  }
}
